export const CREATE_ACCEPT_REQUEST = 'CREATE_ACCEPT_REQUEST' as const
export const UPDATE_ACCEPT_REQUEST = 'UPDATE_ACCEPT_REQUEST' as const
